import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconConvertCurrencyProps } from './IconConvertCurrency.types'
import * as Styled from './styles/IconConvertCurrency.style'

import { nonThemeableRules } from '../../ruleSet'

const IconConvertCurrency: FC<IconConvertCurrencyProps> = ({
  size = nonThemeableRules.defaultSize as number as IconConvertCurrencyProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconConvertCurrencyProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='123.96' cy='124.26' fill='none' r='47.78' vectorEffect='non-scaling-stroke' />
        <path d='M76.18 115.17a47.75 47.75 0 1 1 39.6-47.08 49.32 49.32 0 0 1-.46 6.65' fill='none' vectorEffect='non-scaling-stroke' />
        <path
          d='M56.29 85.93c3 3.26 7.07 6 12 6.19 5.86.18 11.73-3.67 12.64-8.81C82.72 73 75.77 68.62 68 68.39c-7.8-.23-14.74-4.62-12.91-14.92.91-5.14 6.78-9 12.63-8.81 4.89.14 9 2.94 12 6.19m58.8 95.35a16.7 16.7 0 0 1-12.41 5.53c-9.34 0-15.63-7.08-17-17a85.71 85.71 0 0 1-.83-10.49 85.71 85.71 0 0 1 .83-10.49c1.38-9.91 7.67-17 17-17a16.77 16.77 0 0 1 11.87 5M68 92.12v7.94m0-63.94v8.54m33.48 87.43h23.4m-23.4-12.11h23.4'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconConvertCurrency
